import React, { useEffect, useState } from "react";
import ControlLayout from "../components/ControlLayout";
import { api } from "../lib/api";
import { Check } from "lucide-react";

export default function ControlSignals() {
  const [signals, setSignals] = useState([]);

  const refresh = () => api.get("/control-room/signals?limit=100").then((r) => setSignals(r.data));
  useEffect(() => {
    refresh();
    const i = setInterval(refresh, 6000);
    return () => clearInterval(i);
  }, []);

  const ack = async (id) => { await api.post(`/control-room/signals/${id}/ack`); refresh(); };

  return (
    <ControlLayout title="Control Room Signals" subtitle="Observational stream · Control Room never mutates attendance">
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="signals-grid">
        {signals.map((s) => (
          <div key={s.id} className={`border p-4 ${s.acknowledged ? "border-neutral-200 bg-[#FAFAFA] opacity-70" : borderFor(s.severity)}`} data-testid={`signal-card-${s.id}`}>
            <div className="flex items-center justify-between">
              <span className={`px-2 py-0.5 border font-mono text-[10px] uppercase tracking-wider ${sevBadge(s.severity)}`}>{s.severity}</span>
              <span className="mono-label" style={{ fontSize: 10 }}>{new Date(s.created_at_iso).toLocaleTimeString("en-GB")}</span>
            </div>
            <div className="mt-3 font-heading text-lg font-bold tracking-tight">{s.signal_type.replace(/_/g, " ")}</div>
            <div className="mt-2 font-mono text-[11px] text-neutral-700 break-all">{JSON.stringify(s.payload)}</div>
            {!s.acknowledged && (
              <button data-testid={`ack-${s.id}`} onClick={() => ack(s.id)} className="mt-3 h-9 px-3 border border-neutral-900 font-mono text-xs uppercase tracking-wider inline-flex items-center gap-2 hover:bg-black hover:text-white">
                <Check size={14} /> Acknowledge
              </button>
            )}
            {s.acknowledged && <div className="mt-3 mono-label">ACKNOWLEDGED</div>}
          </div>
        ))}
        {signals.length === 0 && (
          <div className="col-span-full border border-neutral-200 bg-[#FAFAFA] p-12 text-center mono-label">
            No signals yet.
          </div>
        )}
      </div>
    </ControlLayout>
  );
}

function borderFor(sev) {
  return sev === "HIGH" ? "border-[#EF4444]" : sev === "MEDIUM" ? "border-[#EAB308]" : "border-neutral-300";
}
function sevBadge(s) {
  return s === "HIGH" ? "border-[#EF4444] bg-[#FEE2E2] text-[#991B1B]"
       : s === "MEDIUM" ? "border-[#EAB308] bg-[#FEF9C3] text-[#854D0E]"
       : s === "LOW" ? "border-neutral-400 bg-neutral-100" : "border-[#22C55E] bg-[#DCFCE7] text-[#166534]";
}
